export default __webpack_public_path__ + "static/media/information--hiking--g1.e7ebd601.png";